import React from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
import { useConsultationForm } from './ConsultationFormContext';
export function FinalCTA() {
  const {
    openForm
  } = useConsultationForm();
  const {
    ref,
    isVisible
  } = useScrollFade();
  return <section className="py-32 bg-[#F0EBE3] relative" data-id="element-105">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center" data-id="element-106">
        <div ref={ref} className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-107">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-text-dark leading-tight mb-6" data-id="element-108">
            The version of you that makes people look twice.
          </h2>

          <p className="text-text-dark/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto" data-id="element-109">
            Book a free consultation and let's build a plan for your skin.
          </p>

          <button onClick={openForm} className="w-full md:w-auto bg-gold hover:bg-[#A6844E] text-white font-bold uppercase tracking-wider px-10 py-5 rounded-sm transition-all duration-300 min-h-[48px] shadow-lg shadow-gold/10" data-id="element-110">
            Book My Free Consultation
          </button>
        </div>
      </div>
    </section>;
}